/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamerBoxStreamerBoxDeviceServicesStartMutationResponse, StreamerBoxStreamerBoxDeviceServicesStartPathParams } from "../models/StreamerBoxStreamerBoxDeviceServicesStart";

export function getStreamerBoxStreamerBoxDeviceServicesStartUrl(uuidOrId: StreamerBoxStreamerBoxDeviceServicesStartPathParams["uuidOrId"], imageId: StreamerBoxStreamerBoxDeviceServicesStartPathParams["imageId"]) {
  const res = { method: 'POST', url: `/streamer-box/devices/${uuidOrId}/services/${imageId}/start` as const }
  return res
}

/**
 * @description Starts a service on the device for the given image id.
 * @summary Start service
 * {@link /streamer-box/devices/:uuidOrId/services/:imageId/start}
 */
export async function streamerBoxStreamerBoxDeviceServicesStart(uuidOrId: StreamerBoxStreamerBoxDeviceServicesStartPathParams["uuidOrId"], imageId: StreamerBoxStreamerBoxDeviceServicesStartPathParams["imageId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StreamerBoxStreamerBoxDeviceServicesStartMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getStreamerBoxStreamerBoxDeviceServicesStartUrl(uuidOrId, imageId).url.toString(), ... requestConfig })
  return res.data
}